import { createSafeContext } from '@/util';

import type { VFrameSliderContextValue } from './type';

export const VFrameSliderContext = createSafeContext<VFrameSliderContextValue>(
  null,
  'VFrameSliderContext',
);
